var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTorreInactivo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 36,
    viewBox: "0 0 30 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 0C6.55242 0.00914062 0.00984375 6.7057 0 14.9702C0 18.8248 2.91586 24.8583 8.66742 32.9006C11.0693 36.2686 15.6839 37.0062 18.9738 34.5473C19.5905 34.0868 20.1333 33.5313 20.5826 32.9006C26.3341 24.8576 29.25 18.8248 29.25 14.9702C29.2409 6.7057 22.6983 0.00914062 14.625 0Z",
    fill: "#C03636"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2841 11.1356L11.7426 12.7328C11.4523 12.915 11.4523 13.3111 11.7426 13.4942L14.2841 15.0914C14.4524 15.1975 14.6742 15.1975 14.8425 15.0914L17.384 13.4942C17.6743 13.3119 17.6743 12.9159 17.384 12.7328L14.8425 11.1356C14.6742 11.0295 14.4524 11.0295 14.2841 11.1356Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2418 28L15.0858 25.4925L19.4106 23.0663L21.0285 28H7.87646L9.51654 23.0407L13.8627 25.4523L8.7945 28H20.2418Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0177 22.5838C19.0306 22.5992 19.0519 22.7575 18.9631 22.7507L14.5098 25.0896L10.0176 22.7019L14.5024 19.5203L19.0177 22.5838Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9399 8.91639L14.474 6L17.009 8.91639H11.9399Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1034 9.52038V12.1887H6.03613L11.1034 9.52038Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9326 9.52038V12.1887H22.9998L17.9326 9.52038Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0672 13.8492V16.5175H6L11.0672 13.8492Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8965 13.8492V16.5175H22.9637L17.8965 13.8492Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0364 19.1071L10.0176 21.9354L11.4164 17.4876L14.0364 19.1071Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.531 17.4885L19.0176 21.9354L14.9331 19.0874L17.531 17.4885Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5908 9.64442L13.8642 10.8969L11.5908 12.0706V9.64442Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5908 16.5175V14.0922L13.8633 15.2651L11.5908 16.5175Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3584 14.0922V16.5175L15.0859 15.2651L17.3584 14.0922Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3584 9.64442V12.0706L15.0859 10.778L17.3584 9.64442Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5715 9.40232L14.5181 10.5316C13.8229 10.1851 13.0777 9.86429 12.4639 9.40232H16.5705H16.5715Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6801 17.4799L14.3359 18.5202C14.4459 18.5895 14.5901 18.5895 14.7001 18.5202L16.3559 17.4799C16.4484 17.4218 16.4955 17.3294 16.4974 17.237H12.5396C12.5414 17.3294 12.5876 17.4218 12.681 17.4799H12.6801Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3554 16.8614L14.6996 15.8211C14.5896 15.7518 14.4453 15.7518 14.3353 15.8211L12.6795 16.8614C12.5871 16.9196 12.5399 17.012 12.5381 17.1044H16.4959C16.4941 17.012 16.4478 16.9196 16.3545 16.8614H16.3554Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTorreInactivo);
export default __webpack_public_path__ + "static/media/torre-inactivo.a316b42ca2910dec343a2a07fcda5fca.svg";
export { ForwardRef as ReactComponent };